import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="bg-[#111827]  py-8 hidden lg:block md:block">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-between pl-10 items-center">
          {/* Contact Section */}
          <div className="w-full md:w-1/3  mb-6 md:mb-0">
            <h2 className="text-xl font-semibold text-white">
              Let's keep in touch!
            </h2>
            <p className="text-white">
              Find us on any of these platforms, we respond in 1-2 business
              days.
            </p>
            <div className="flex mt-4">
              <a
                href="https://x.com/gsminstiute"
                className="text-blue-500 hover:text-blue-300 mx-2"
              >
                <i className="fab fa-twitter fa-2x"></i>
              </a>
              <a
                href="https://www.facebook.com/gsmtradinginstitute"
                className="text-blue-700 hover:text-blue-300 mx-2"
              >
                <i className="fab fa-facebook fa-2x"></i>
              </a>
              <a
                href="https://www.instagram.com/gsmtradinginstitute/"
                className="text-pink-500 hover:text-pink-700 mx-2"
              >
                <i className="fab fa-instagram fa-2x"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/gsm-trading-institute-04535934b/"
                className="text-white hover:text-gray-300 mx-2"
              >
                <i className="fab fa-linkedin fa-2x"></i>
              </a>
            </div>
          </div>

          {/* Useful Links Section */}
          <div className="w-full md:w-1/4 mb-6 md:mb-0">
            <h2 className="text-lg font-semibold text-white">USEFUL LINKS</h2>
            <ul className="mt-4 space-y-2">
              <li>
                <a
                  href="/"
                  className="text-white hover:text-gray-200 hover:underline"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  rel="noopener noreferrer"
                  href="/all-courses"
                  className="text-white hover:text-gray-200 hover:underline"
                  target="_blank"
                >
                  Courses
                </a>
              </li>
              <li>
                <a
                  rel="noopener noreferrer"
                  href="/student/purchased"
                  className="text-white hover:text-gray-200 hover:underline"
                  target="_blank"
                >
                  My Purchased
                </a>
              </li>
              <li>
                <a
                  rel="noopener noreferrer"
                  href="/profile"
                  className="text-white hover:text-gray-200 hover:underline"
                  target="_blank"
                >
                  Profile
                </a>
              </li>
            </ul>
          </div>

          {/* Other Resources Section */}
          <div className="w-full md:w-1/3">
            <h2 className="text-lg font-semibold text-white">
              OTHER RESOURCES
            </h2>
            <ul className="mt-4 space-y-2">
              <li>
                <a
                  rel="noopener noreferrer"
                  href="/aboutus"
                  className="text-white hover:text-gray-200 hover:underline"
                  target="_blank"
                >
                  About Us
                </a>
              </li>

              <li>
                <a
                  rel="noopener noreferrer"
                  href="/termsconditon"
                  className="text-white hover:text-gray-200 hover:underline"
                  target="_blank"
                >
                  Terms & Conditions
                </a>
              </li>
              <li>
                <a
                  rel="noopener noreferrer"
                  href="/privacypolicy"
                  className="text-white hover:text-gray-200 hover:underline"
                  target="_blank"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  rel="noopener noreferrer"
                  href="/contactUs"
                  className="text-white hover:text-gray-200 hover:underline"
                  target="_blank"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="mt-8 border-t border-gray-300 pt-4 text-center">
          <p className="text-white">
            {" "}
            © {new Date().getFullYear()} GSM Trading Institute. All Rights
            Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
